import React from 'react';

const TopDivider = () => {
  return <div className="topbrick-divider"></div>;
};

export default TopDivider;

